import { Fragment } from "react";
import Home from "./pages/Home";

const App = () => {
  return (
    <Fragment>
      <Home />
    </Fragment>
  );
};

export default App;
